<template>
  <el-dialog
      title="应用预审核"
      :visible="dialogVisible"
      width="650px"
      @close="dialogVisible = false"
      :close-on-click-modal="false"
      center
  >
    <div class="info">
      <el-image
          style="width: 80px; height: 80px"
          :src="formData.apkIcon"
          fit="fit"
      ></el-image>
      <div class="info-detail">
        <p class="fontsize-24">{{ formData.apkName }}</p>
        <p>包名：{{ formData.apkPackage }}</p>
      </div>
    </div>
    <el-form :model="formData" ref="refForm" label-width="130px" :disabled="type === 'view'">
      <el-form-item
          label="预审核是否通过"
          prop="state"
          :rules="[{ required: true, message: '请选择审核结果'}]"
      >
        <el-radio-group v-model="formData.state">
          <el-radio :label="2">通过</el-radio>
          <el-radio :label="3">不通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
          v-if="formData.state == 3"
          label="不通过原因说明"
          prop="remark"
          :rules="[{ required: true, message: '请填写原因'}]"
      >
        <el-input
            :rows="4"
            :maxlength="250"
            show-word-limit
            type="textarea"
            v-model="formData.remark"
            placeholder="请输入原因"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" v-if="type == 'approve'">
      <el-button size="medium" type="primary" @click="onSubmit()">保存</el-button>
      <el-button size="medium" type="info" @click="dialogVisible = false">取消</el-button>
    </div>
    <div slot="footer" v-else>
      <el-button size="medium" type="info" @click="dialogVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  data() {
    const numberRule = (rule, value, callback) => {
      if (Number(value) >= this.formData.expireDay) {
        if (Number.isInteger(Number(value)) && Number(value) >= 0) {
          if (Number(value) <= 180) {
            callback()
          } else {
            callback(new Error('不可大于180'))
          }
        } else {
          callback(new Error('请输入大于零的正整数'))
        }
      } else {
        callback(new Error('不能小于0'))
      }
    }
    return {
      numberRule: numberRule,
      type: '', // view、approve
      //显示dialog
      dialogVisible: false,
      //数据
      formData: {
        state: '',
        remark: '',
      }
    };
  },
  methods: {
    showDialog(row, type) {
      this.dialogVisible = true
      this.type = type
      this.getDetail(row)
    },
    getDetail({id}) {
      this.$apis.preAuditServer.queryIdentifyDetail({id}).then(res => {
        if (res['code'] == 0) {
          this.formData = res.data
        }
      });
    },
    //提交
    onSubmit() {
      this.$refs['refForm'].validate((valid) => {
        const {id, state, remark} = this.formData
        if (valid) {
          this.$apis.preAuditServer.editIdentifyState({
            id,
            state,
            remark: state == 3 ? remark : '',
          }).then(res => {
            if (res['code'] == 0) {
              this.$emit("refresh");
              this.$message({
                message: '审核成功',
                type: "success"
              });
              this.dialogVisible = false;
            } else {
              this.$message({
                message: res['msg'],
                type: "error"
              });
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.info {
  padding: 30px 0;
  display: flex;
  flex-wrap: nowrap;
  border-bottom: 1px dashed #aaa;
  border-top: 1px solid #aaa;

  &-detail {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
}
</style>
